var FEATURES = {
    GUEST_CHECKOUT: 'guest-checkout',
};
export default FEATURES;



//////////////////
// WEBPACK FOOTER
// ./src/utils/Features.ts
// module id = null
// module chunks = 